import { Component, OnInit, Inject } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SipJsService } from '../../shared/service/sipjsServices.class';
/* import { DialogData } from '../alertcallback/alertcallback.component'; */

@Component({
  selector: 'app-dialpad',
  templateUrl: './dialpad.component.html',
  styleUrls: ['./dialpad.component.css']
})
export class DialpadComponent implements OnInit {
  number=[];
  setError:any=" ";
 
  constructor(public dialog: MatDialogRef<DialpadComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private sipdata : SipJsService) { }

  ngOnInit() {
  }

  onClick(key) {
    console.log("keypress");
    console.log(key);
    this.number.push(key);
    this.sipdata.SendDTMF(key);
  }

  onClickClear()
  {
    this.number = [];
    return this.number;
  }

  Close()
  {
    this.dialog.close();
  }

}